import Vue from 'vue';
import {BallPulseLoader} from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner';
import HttpMixin from '@/mixins/HttpMixin';
import CheckboxControl from "@/componentsReusable/CheckboxControl.vue";
import distanceInWords from 'date-fns/distance_in_words';
import MessageConvo from "@/components/communications/cards/MessageConvo";
import ActionsDropdown from "@/componentsReusable/dropdowns/ActionsDropdown.vue";
import {
  ActionPayload,
  MESSAGE_ACTIONS,
  MessageAction,
  ReadActionPayload
} from "@/components/communications/cards/actions/Actions";

export default Vue.component('message-item', {
  props: {
    message: { type: Object },
    currentDateTime: { type: Date },
  },
  name: 'MessageItem',
  data () {
    return {
      loading: false,
      showActions: false,
      actions: MESSAGE_ACTIONS,
      actionTop: null as number | null,
      actionRight: 10
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner,
    CheckboxControl,
    MessageConvo,
    ActionsDropdown
  },
  mixins: [ HttpMixin ],
  filters: {
    timeAgo(incomingDate: Date, currentDateTime: Date){
      return distanceInWords(
        incomingDate,
        currentDateTime
      );
    }
  },
  computed: {
    rightSideId(): string {
      return `message-${this.message.id}-right-side`;
    },
    hasFailed(): Boolean{
      switch (this.message.deliveryStatus) {
        case "failed":
        case "undelivered":
          return true;
        default:
          return false;
      }
    }
  },
  methods: {
    openActions() {
      this.showActions = !this.showActions;
    },
    async actionSelected(actionId: number) {
      this.closeActions();
      const actionPayload = this.getPayload();
      switch (actionId) {
        case MessageAction.MarkUnread:
          await this.updateReadStatus(actionPayload as ReadActionPayload, false);
          break;
        case MessageAction.MarkRead:
          await this.updateReadStatus(actionPayload as ReadActionPayload, true);
          break;
        case MessageAction.Close:
          this.closeMessage()
          break;
        case MessageAction.OptOut:
          this.$emit('message-opt-out', actionPayload);
          break;
      }
    },
    getPayload(): ActionPayload {
      return { messageIds: [ this.message.id ] };
    },
    closeActions() {
      this.showActions = false;
    },
    async updateReadStatus(payload: ReadActionPayload, isRead: boolean) {
      payload.isRead = isRead;
      this.$emit('message-read', payload);
    },
    closeMessage() {
      this.$emit('message-closed', this.getPayload());
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/communications/cards/MessageItem.ts